import { render, staticRenderFns } from "./criticalComponentJob.vue?vue&type=template&id=5ec8fd98"
import script from "./criticalComponentJob.vue?vue&type=script&lang=js"
export * from "./criticalComponentJob.vue?vue&type=script&lang=js"
import style0 from "./criticalComponentJob.vue?vue&type=style&index=0&id=5ec8fd98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports